import React, { useState } from 'react';
import { Button } from '@chakra-ui/react';
import { useContactInfoDispatch, useCheckoutState } from '@olo-web/client-state';
import { useSignup } from '@olo-web/domain/customer';
import { useFormContext } from 'react-hook-form';
import { useCheckoutDispatch } from '@olo-web/client-state';
import { useError } from '@olo-web/utils/common/hooks';
import { useSendEvent } from '@olo-web/utils/common/hooks';
import { EAnalyticsEventNames } from '@olo-web/types/enums';

declare const window: any;

export const VerifyCreditCardButton = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const focusRingStyle = {
    outline: '3px solid #000',
    outlineOffset: '3px',
    boxShadow: 'none',
  };
  const { handleSubmit } = useFormContext();
  const { invalidCollectJsInputFieldNames: invalid } = useCheckoutState();
  const callError = useError();
  const { sendEvent } = useSendEvent();
  const checkoutDispatch = useCheckoutDispatch();
  const contactInfoDispatch = useContactInfoDispatch();
  const { mutateAsync: signup } = useSignup();

  const submitHandler = async (data) => {
    setIsLoading(true);
    if (data.email) {
      try {
        await signup(data);
      } catch (e) {
        //eslint-disable-line no-empty
      } finally {
        contactInfoDispatch({
          type: 'SUBMIT',
          payload: {
            email: data.email,
            firstName: '',
            lastName: '',
            phoneNo: '',
          },
        });
      }
    }

    if (!window.CollectJS) {
      callError({
        error: new Error('No CollectJS loaded - "Add credit card" click!'),
        logError: true,
        toastError: true,
        title: 'Unable to load payment provider',
        description: 'Please refresh your page',
      });
      return;
    }
    checkoutDispatch({
      type: 'SET_ZIP_CODE',
      payload: data?.payments?.[0]?.creditCardInfo?.zipCode,
    });
    sendEvent(EAnalyticsEventNames.ADD_PAYMENT_INFO);
    window.CollectJS.startPaymentRequest();
  };

  return (
    <Button
      size="lg"
      colorScheme="primary"
      alignSelf="flex-end"
      onClick={handleSubmit(submitHandler)}
      isLoading={isLoading && !invalid?.length}
      loadingText="Verifying card..."
      w={{ base: '100%', md: 'auto' }}
      data-testid="continue-to-review-button"
      mt="16px !important"
      _focus={{ boxShadow: 'none' }}
      _focusVisible={focusRingStyle}
    >
      {children}
    </Button>
  );
};
